import React                        from 'react';
import { bgaPlacements as tooltip } from 'pu-data/Tooltips';
import TextComponent                from './TextComponent';

const BgaPlacements = (props) => {
  const name = 'bga';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="BGA<br />Placements"
      name={name}
      inputId={props.inputId}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      inputClassName={props.inputClassName}
      errorMessage={props.errorMessage} />
  );
};

BgaPlacements.defaultProps = {
  inputId: 'bga-placement',
};

export default BgaPlacements;
